@use '@design/design-tokens/breakpoints/breakpoints' as *;

.alert {
  position: fixed;
  z-index: var(--z-index-toast);
  right: 24px;
  top: 24px;

  @include respond-to('mobile') {
    left: 50%;
    width: 300px;
    transform: translate(-50%, 0);
  }
}
